export class ImageSource {
    constructor(
        public media: string,
        public sourceSet: string
    ) {}
}
